import { render, staticRenderFns } from "./relSaldosNaoUtilizados.vue?vue&type=template&id=b1fe35d8"
import script from "./relSaldosNaoUtilizados.vue?vue&type=script&lang=ts"
export * from "./relSaldosNaoUtilizados.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports